export default __webpack_public_path__ + "static/garden-salad-b9ee8439f250d29d10f1fd3d9db69241.jpg";